import axios from 'axios';

import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { PARTNER_PRODUCTS_GET } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

const api_get_products_partners = (whatIfId) => {
    return (dispatch, getState) => {

        Auth.currentSession().then((session) => {

            const token = session && session.idToken.jwtToken;

            var config = { headers: { Authorization: 'Bearer ' + token } };

            return axios.get(`${Config.API_BASE_URL}/PartnerWhatIf/productDetail/${whatIfId}`, config)
                .then(response => {
                    dispatch({
                        type: PARTNER_PRODUCTS_GET,
                        payload: {
                            projectDetail: {
                                ...response.data,
                            },
                            errors: {},
                            task: {
                                result: true
                            }
                        }
                    });
                })
                .catch(error => {
                    throw (error);
                });
        }).catch(error => {
            // dispatch({ type: EXPIRED });
        });
    };
}

export default api_get_products_partners;
